import React, { Component } from 'react'
import ChatMessage from './ChatMessage'

class PinnedMessages extends Component {
  constructor (props) {
    super(props)

    this.state = {
      height: ''
    }

    this.setHeight = this.setHeight.bind(this)
  }

  setHeight (height) {
    this.setState({ height: height + height / 17 * 8 + 'px' })
  }

  render () {
    const msgs = this.props.msgs.filter(m => m.pinned)
    if (msgs.length === 0) return null
    return (
      <div
        className='y-scroll-wrap chat-field pinned-msgs'
        style={{ height: this.state.height, marginLeft: 0 }}>
        <div className='y-scroll' style={{ marginLeft: '10px' }}>
          <div className='chat-tabs-content'>
            <div className='chat-general-tab'>
              {msgs && msgs.map((msg, index) =>
                <ChatMessage
                  pinned
                  index={index}
                  key={msg._id}
                  msg={msg}
                  setParentHeight={this.setHeight} />
              )}
            </div>
          </div>
        </div>
        <div className='pinned-border' />
      </div>
    )
  }
}

export default PinnedMessages



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/PinnedMessages.js